/* Feinkost Angelo - Bilderreihe auf der Produktseite.
   Ohne JavaScript ist das erste Bild zu sehen (es traegt die Markierung schon im Liquid);
   das Skript ergaenzt Miniaturen, Pfeile, Wischen und Pfeiltasten. */
(function () {
  'use strict';

  function start(bereich) {
    var galerien = (bereich || document).querySelectorAll('[data-fa-galerie]:not([data-fa-galerie-bereit])');
    Array.prototype.forEach.call(galerien, function (galerie) {
      galerie.setAttribute('data-fa-galerie-bereit', '1');

      var bilder = galerie.querySelectorAll('[data-fa-schau]');
      var minis = galerie.querySelectorAll('[data-fa-miniatur]');
      if (bilder.length === 0) return;

      var i = 0;

      function zeige(n) {
        i = (n + bilder.length) % bilder.length;
        Array.prototype.forEach.call(bilder, function (b, k) {
          b.classList.toggle('aktiv', k === i);
        });
        Array.prototype.forEach.call(minis, function (m, k) {
          m.classList.toggle('aktiv', k === i);
          m.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
      }

      /* Sicherheitsnetz: falls im Liquid keine Markierung gesetzt ist */
      zeige(0);
      if (bilder.length < 2) return;

      Array.prototype.forEach.call(minis, function (m, k) {
        m.addEventListener('click', function () { zeige(k); });
      });

      var zurueck = galerie.querySelector('[data-fa-zurueck]');
      var vor = galerie.querySelector('[data-fa-vor]');
      if (zurueck) zurueck.addEventListener('click', function () { zeige(i - 1); });
      if (vor) vor.addEventListener('click', function () { zeige(i + 1); });

      /* Wischen auf dem Handy */
      var startX = null;
      galerie.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      galerie.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var weg = e.changedTouches[0].clientX - startX;
        if (Math.abs(weg) > 40) zeige(weg < 0 ? i + 1 : i - 1);
        startX = null;
      }, { passive: true });

      /* Pfeiltasten */
      galerie.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); zeige(i - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); zeige(i + 1); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
